module.exports = __webpack_public_path__ + "img/betonConservering.79098fab.jpg";